export default __webpack_public_path__ + "static/extravagant-header-paranella-178e9e6e4c52e43047a90eab7ed448a0.jpg";